import React from 'react';
import { ShieldAlertIcon } from 'lucide-react';
import { discoveryProtocols } from '../data/discovery';
import { PageHeader } from '../components/PageHeader';
import { SourceRef } from '../components/SourceRef';
import { DataBadge } from '../components/DataBadge';
import { COMPILED_LABEL } from '../data/sources';
export function Discovery() {
  return <>
      <PageHeader title="Discovery" lede="How agents announce their presence. These are the machine-readable signals a census can legitimately read — published by agents, for machines." data-id="element-1112" data-mp="1ac5anhpykczw">
        <DataBadge mode="snapshot" source="Protocol specs, illustrative payloads" asOf={COMPILED_LABEL} data-id="element-1113" data-mp="1y3kjltc8psk4" />
      </PageHeader>

      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-1114" data-mp="1u2qr0mnurpkw">
        {discoveryProtocols.map(p => <section key={p.id} aria-labelledby={`${p.id}-title`} className="grid gap-8 border-b border-line py-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]" data-id="element-1115" data-mp="mpgogjtx1ydh">
            <div data-id="element-1116" data-mp="q6cpiar5l87c">
              <div className="flex items-center gap-3" data-id="element-1117" data-mp="q5uoz1xgk7tm">
                <h2 id={`${p.id}-title`} className="font-serif text-2xl text-ink md:text-3xl" data-id="element-1118" data-mp="q49q504422py">
                  {p.name}
                </h2>
                <span className={`rounded-full border px-2 py-0.5 font-mono text-[10.5px] ${p.status === 'Live' ? 'border-live/40 text-live' : 'border-machine/40 text-machine'}`} data-id="element-1119" data-mp="h67msdwwmxzi">{p.status}</span>
              </div>
              <p className="mt-3 break-words font-mono text-[12.5px] text-human" data-id="element-1120" data-mp="7etog9gow47y">{p.endpoint}</p>
              <p className="mt-4 max-w-lg text-[14.5px] leading-relaxed text-ink/85" data-id="element-1121" data-mp="c7mtyzjzfgl3">
                {p.description}
                <SourceRef id={p.sourceId} data-id="element-1122" data-mp="3tonwawzn80fc" />
                {p.extraSourceId && <SourceRef id={p.extraSourceId} data-id="element-1123" data-mp="2g8li2a1z6ft" />}
              </p>
            </div>
            <figure className="min-w-0 overflow-hidden rounded-lg border border-line bg-surface" data-id="element-1124" data-mp="3kmn2ka3mbwif">
              <figcaption className="border-b border-line px-4 py-2 font-mono text-[11px] text-muted" data-id="element-1125" data-mp="3pl80u3zb8648">{p.payloadLabel}</figcaption>
              <pre className="max-h-[420px] overflow-auto p-4 font-mono text-[12px] leading-relaxed text-ink/90" data-id="element-1126" data-mp="1v6axzpx85v23">
                <code data-id="element-1127" data-mp="1qczr5osexea6">{p.payload}</code>
              </pre>
            </figure>
          </section>)}

        <aside role="note" className="mt-12 rounded-lg border border-signal/50 bg-signal/[0.06] p-6 md:p-8" data-id="element-1128" data-mp="1lfpt5kqyjuaq">
          <div className="flex items-start gap-4" data-id="element-1129" data-mp="1hbrtn8xq0hh5">
            <ShieldAlertIcon className="mt-1 h-6 w-6 shrink-0 text-signal" aria-hidden="true" data-id="element-1130" data-mp="2e4djvvuh7bvo" />
            <div data-id="element-1131" data-mp="294sileru2rfs">
              <h2 className="text-lg font-medium text-ink" data-id="element-1132" data-mp="296c17c0ypekq">Read published cards. Never probe.</h2>
              <p className="mt-2 max-w-3xl text-[15px] leading-relaxed text-ink/85" data-id="element-1133" data-mp="25248l3rdveh8">
                Reading published agent cards and registry entries is designed-for-machines public data. Never probe, scan, or connect to an instance you do not own. The 2026 OpenClaw crisis (9+ CVEs, 341 malicious skills, 312k exposed instances) is the cautionary tale.
                <SourceRef id="guard0" data-id="element-1134" data-mp="30cspr5afqmox" />
              </p>
            </div>
          </div>
        </aside>
      </div>
    </>;
}